import MainContainer from "../../components/MainContainer"
import MainHeader from "../../components/MainHeader"
import Title from "../../components/Title"
import { Button, Grid2 } from "@mui/material"
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper"
import AutomationBox from "../../components/AutomationBox"
import { useEffect, useState } from "react"
import ModalAutomation from "../../components/ModalAutomation"
import { toast } from "react-toastify"

import api from "../../services/api"

function AutoDM() {
    const [selectedAutomation, setSelectedAutomation] = useState(null)
    const [openModalAutomation, setOpenModalAutomation] = useState(false)

    const [data, setData] = useState([])

    async function getData() {
        try {
            const response = await api.get("/automation/list")
            setData(response.data)
        } catch (error) {
            toast.error("Erro ao buscar automações")
        }
    }

    useEffect(() => {
        getData()
    }, [])

    const handleNewAutomation = () => {
        setOpenModalAutomation(true)
    }

    const handleEditAutomation = (id) => {
        setSelectedAutomation(id)
        setOpenModalAutomation(true)
    }

    const handleCloseModalAutomation = () => {
        setOpenModalAutomation(false)
        setSelectedAutomation(null)
    }

    const handleSaveAutomation = () => {
        getData()
        setSelectedAutomation(null)
    }

    const handleChangeActivation = async (id, status) => {
        try {
            await api.put(`/automation/byId/${id}`, {
                active: status,
            })

            setData(
                data.map((item) =>
                    item.id === id ? { ...item, active: status } : item,
                ),
            )
        } catch (error) {
            toast.error("Erro ao atualizar automação")
        }
    }

    const handleDeleteAutomation = async (id) => {
        try {
            await api.delete(`/automation/byId/${id}`)

            setData(data.filter((item) => item.id !== id))
        } catch (error) {
            toast.error("Erro ao excluir automação")
        }
    }

    return (
        <MainContainer>
            <ModalAutomation
                open={openModalAutomation}
                handleClose={handleCloseModalAutomation}
                onSaveAutomation={handleSaveAutomation}
                selectedAutomationId={selectedAutomation}
            />
            <MainHeader>
                <Title>Automação de redes sociais</Title>
            </MainHeader>

            <MainHeaderButtonsWrapper>
                <Button variant="contained" onClick={handleNewAutomation}>
                    Nova automação
                </Button>
            </MainHeaderButtonsWrapper>

            <Grid2 container>
                <Grid2
                    size={{
                        xs: 12,
                    }}
                >
                    {data.map((item) => (
                        <AutomationBox
                            key={item.id}
                            name={item.title}
                            executionCounting={item.interactionsCount}
                            hooks={item.triggers}
                            actions={item.actions}
                            handleEdit={() => handleEditAutomation(item.id)}
                            isActive={item.active}
                            handleDelete={() => handleDeleteAutomation(item.id)}
                            handleChangeActivation={() =>
                                handleChangeActivation(
                                    item.id,
                                    item.active ? false : true,
                                )
                            }
                        />
                    ))}
                </Grid2>
            </Grid2>
        </MainContainer>
    )
}

export default AutoDM
